/**
 * Cookie read/write helpers with JSON support.
 * Used for small persistent data (theme, trainer profile, last team ID).
 * Larger data (teams, sprites) goes to IndexedDB.
 */

/** Set a cookie with a JSON-serializable value. Expires in `days` days. */
export function setCookie(key: string, value: unknown, days = 365): void {
  const json = JSON.stringify(value);
  const encoded = encodeURIComponent(json);
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${key}=${encoded}; expires=${expires}; path=/; SameSite=Lax`;
}

/** Read a cookie and parse it as JSON. Returns `fallback` if missing or invalid. */
export function getCookie<T>(key: string, fallback: T): T {
  const cookies = document.cookie.split("; ");
  for (const c of cookies) {
    const eq = c.indexOf("=");
    if (eq === -1) continue;
    const k = c.slice(0, eq);
    if (k === key) {
      const raw = decodeURIComponent(c.slice(eq + 1));
      try {
        return JSON.parse(raw) as T;
      } catch {
        return fallback;
      }
    }
  }
  return fallback;
}

/** Remove a cookie by setting its expiry to the past. */
export function removeCookie(key: string): void {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}
